/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientCompanySourcingHubContextResource
 */
export interface ClientCompanySourcingHubContextResource {
    /**
     * 
     * @type {boolean}
     * @memberof ClientCompanySourcingHubContextResource
     */
    displaySearchOnboardingModal: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClientCompanySourcingHubContextResource
     */
    displayMicroConsultingBanner: boolean;
}

/**
 * Check if a given object implements the ClientCompanySourcingHubContextResource interface.
 */
export function instanceOfClientCompanySourcingHubContextResource(value: object): value is ClientCompanySourcingHubContextResource {
    if (!('displaySearchOnboardingModal' in value) || value['displaySearchOnboardingModal'] === undefined) return false;
    if (!('displayMicroConsultingBanner' in value) || value['displayMicroConsultingBanner'] === undefined) return false;
    return true;
}

export function ClientCompanySourcingHubContextResourceFromJSON(json: any): ClientCompanySourcingHubContextResource {
    return ClientCompanySourcingHubContextResourceFromJSONTyped(json, false);
}

export function ClientCompanySourcingHubContextResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCompanySourcingHubContextResource {
    if (json == null) {
        return json;
    }
    return {
        
        'displaySearchOnboardingModal': json['displaySearchOnboardingModal'],
        'displayMicroConsultingBanner': json['displayMicroConsultingBanner'],
    };
}

export function ClientCompanySourcingHubContextResourceToJSON(value?: ClientCompanySourcingHubContextResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'displaySearchOnboardingModal': value['displaySearchOnboardingModal'],
        'displayMicroConsultingBanner': value['displayMicroConsultingBanner'],
    };
}

